import React from 'react';
import { Box, Container, VStack, Heading, Text } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const Confidentialite = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)">
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]}>
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="linear-gradient(135deg, #0053b3 0%, #ef3340 100%)"
          py={{ base: 12, lg: 16 }}
        >
          <Container maxW="1200px" px={5}>
            <Heading as="h1" size={{ base: 'xl', md: '2xl' }} color="white" fontWeight={800} textAlign="center">
              🔒 Politique de confidentialité
            </Heading>
          </Container>
        </Box>

        <Container maxW="1000px" px={5} py={10}>
          <VStack spacing={8} align="start">
            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>1. Responsable du traitement</Heading>
              <VStack align="start" spacing={2}>
                <Text>Le traitement des données personnelles collectées sur le site https://rester-en-france.fr est effectué par :</Text>
                <Text fontWeight={700}>UNISAVE LTD</Text>
                <Text>207 Regent Street, W1B 3HH, Londres, Royaume-Uni</Text>
                <Text>Numéro d’immatriculation : 14217440</Text>
                <Text>Email : contact@rester-en-france.fr</Text>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>2. Données collectées</Heading>
              <VStack align="start" spacing={2}>
                <Text>Nous collectons uniquement les données strictement nécessaires au traitement de votre demande :</Text>
                <VStack align="start" spacing={1} pl={4}>
                  <Text>• Nom, prénom</Text>
                  <Text>• Adresse e-mail et numéro de téléphone</Text>
                  <Text>• Informations relatives à votre situation administrative ou titre de séjour</Text>
                  <Text>• Pièces justificatives nécessaires à la constitution de votre dossier</Text>
                </VStack>
                <Text>Ces informations sont fournies volontairement par l’utilisateur via les formulaires du site.</Text>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>3. Finalité du traitement</Heading>
              <VStack align="start" spacing={2}>
                <Text>Les données sont collectées afin de :</Text>
                <VStack align="start" spacing={1} pl={4}>
                  <Text>• Gérer et suivre les demandes d’accompagnement administratif</Text>
                  <Text>• Communiquer avec les utilisateurs</Text>
                  <Text>• Améliorer les services proposés sur le site</Text>
                </VStack>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>4. Base légale</Heading>
              <Text>Le traitement repose sur votre consentement explicite au moment de la soumission du formulaire (article 6.1.a du RGPD).</Text>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>5. Durée de conservation</Heading>
              <Text>Les données sont conservées pendant une durée maximale de 24 mois à compter du dernier contact, sauf obligation légale contraire.</Text>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>6. Partage des données</Heading>
              <VStack align="start" spacing={2}>
                <Text>Aucune donnée personnelle n’est cédée ou vendue à des tiers.</Text>
                <Text>Elles peuvent être transmises uniquement aux partenaires techniques nécessaires au traitement du dossier (hébergeur, outils CRM, etc.), dans le respect du RGPD.</Text>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>7. Vos droits</Heading>
              <VStack align="start" spacing={2}>
                <Text>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</Text>
                <VStack align="start" spacing={1} pl={4}>
                  <Text>• Droit d’accès</Text>
                  <Text>• Droit de rectification</Text>
                  <Text>• Droit d’effacement</Text>
                  <Text>• Droit d’opposition</Text>
                  <Text>• Droit à la portabilité</Text>
                </VStack>
                <Text>Vous pouvez exercer vos droits en écrivant à contact@rester-en-france.fr.</Text>
              </VStack>
            </Box>
          </VStack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default Confidentialite;
